import TrendingTags from "./trendingTags";

export default TrendingTags;